var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0.666687H2.66671C1.93337 0.666687 1.33337 1.26669 1.33337 2.00002V11.3334H2.66671V2.00002H10.6667V0.666687ZM12.6667 3.33335H5.33337C4.60004 3.33335 4.00004 3.93335 4.00004 4.66669V14C4.00004 14.7334 4.60004 15.3334 5.33337 15.3334H12.6667C13.4 15.3334 14 14.7334 14 14V4.66669C14 3.93335 13.4 3.33335 12.6667 3.33335ZM12.6667 14H5.33337V4.66669H12.6667V14Z",
    fill: "#9CA0A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bf4692431e482b04f04d2cc8cb2fc826.svg";
export { ForwardRef as ReactComponent };